import Heading from '../typography';
import { TagWrapper } from './lozenge.styled';

interface TagType {
  variant:
    | 'default'
    | 'default-outline'
    | 'primary'
    | 'primary-outline'
    | 'success'
    | 'success-outline'
    | 'error'
    | 'error-outline'
    | 'error-dark'
    | 'info'
    | 'info-outline'
    | 'custom'
    | 'pink-tag';
  title: string;
  className?: string;
  hasDot?: boolean;
  icon?: string;
  color?: string;
  popoverClassName?: string; // special class for popovers
  tagColor?: string;
}

const Tag = ({
  variant,
  title,
  className,
  hasDot,
  icon,
  color,
  popoverClassName,
  tagColor,
}: TagType): JSX.Element => {
  return (
    <TagWrapper
      variant={variant}
      tagColor={tagColor}
      className={`${className ?? ''} ${popoverClassName ?? ''}`}>
      {(hasDot ?? false) && <div className={`dot ${popoverClassName ?? ''}`} />}
      {icon != null && (
        <span className={`material-symbols-outlined ${popoverClassName ?? ''}`}>{icon}</span>
      )}
      <Heading variant='body-xs' title={title} className={popoverClassName} color={color} />
    </TagWrapper>
  );
};

export default Tag;
